import { render, staticRenderFns } from "./VendorBadanUsaha.vue?vue&type=template&id=2ac7371a&"
import script from "./VendorBadanUsaha.vue?vue&type=script&lang=js&"
export * from "./VendorBadanUsaha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports